import { render } from "./CreateReviewModal.vue?vue&type=template&id=242067d6&lang=true"
import script from "./CreateReviewModal.vue?vue&type=script&lang=js"
export * from "./CreateReviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__